/* Happy Yay — Bundle & Save picker (assets/hy-bundle-save.js)
   Pairs with snippets/hy-bundle-save.liquid + assets/hy-bundle-save.css.
   Initialises every .hybs block on the page. No dependencies. */
(function(){
function init(root){
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var form = root.closest('form') || document.querySelector('form[action*="/cart/add"]');
  var hidden = root.querySelector('[data-hybs-input]');
  // Remove theme's own quantity inputs in this form so ours is the only one submitted.
  function claimQty(){
    if (!form) return;
    var others = [].slice.call(form.querySelectorAll('[name="quantity"]'));
    if (form.id) others = others.concat([].slice.call(document.querySelectorAll('[name="quantity"][form="' + form.id + '"]')));
    others.forEach(function(el){ if (el !== hidden){ el.setAttribute('data-hybs-muted-name', 'quantity'); el.removeAttribute('name'); } });
    if (!form.contains(hidden)) { if (form.id) hidden.setAttribute('form', form.id); else form.appendChild(hidden); }
  }
  claimQty();
  if (form) form.addEventListener('submit', function(){ claimQty(); hidden.value = qty; }, true);

  var variants = {}; try { variants = JSON.parse(root.querySelector('[data-hybs-variants]').textContent); } catch(e){}
  var price = +root.dataset.price;
  var label = root.dataset.label, plural = root.dataset.plural;
  var popular = +root.dataset.popular;
  var tiers = root.dataset.tiers.split(',').map(function(t){ var p=t.split(':'); return {q:+p[0], pct:+p[1]}; }).sort(function(a,b){return a.q-b.q;});
  var maxQ = tiers.length ? tiers[tiers.length-1].q : 1;
  var qty = Math.max(1, +root.dataset.default || 1);
  root._hybsQty = function(){ return qty; };
  root._hybsPct = function(){ return pctFor(qty); };
  var fmtStr = root.dataset.moneyFormat || ('$' + '{' + '{amount}' + '}');

  function money(cents){
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, fmtStr);
    var v = (cents/100).toFixed(2);
    return fmtStr.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  function pctFor(q){ var p=0; tiers.forEach(function(t){ if (q>=t.q) p=t.pct; }); return p; }

  var rowsEl = root.querySelector('[data-hybs-rows]');
  var rowDefs = [{q:1,pct:0}].concat(tiers);

  function renderRows(){
    rowsEl.innerHTML = rowDefs.map(function(r, i){
      var isLast = i === rowDefs.length-1;
      var each = Math.round(price*(1-r.pct/100));
      var full = price*r.q, tot = Math.round(full*(1-r.pct/100));
      var name = (isLast && r.q>1 ? r.q+'+ ' : r.q+' ') + (r.q===1 ? label : plural);
      return '<button type="button" class="hybs-row" role="radio" data-q="'+r.q+'" data-last="'+(isLast?1:0)+'">'+
        '<span class="hybs-radio"></span>'+
        '<span class="hybs-main"><span class="hybs-line"><span class="hybs-name">'+name+'</span>'+
          (r.pct ? '<span class="hybs-off">Save '+r.pct+'%</span>' : '')+
          (r.q===popular ? '<span class="hybs-pop">Most picked</span>' : '')+
        '</span><span class="hybs-each">'+money(each)+' each</span></span>'+
        '<span class="hybs-price"><b>'+money(tot)+'</b>'+(r.pct ? '<s>'+money(full)+'</s>' : '')+'</span>'+
      '</button>';
    }).join('');
  }

  var lastTot = null;
  function bump(el){ el.classList.remove('hybs-bump'); void el.offsetWidth; el.classList.add('hybs-bump'); }
  function update(){
    var pct = pctFor(qty), full = price*qty, tot = Math.round(full*(1-pct/100));
    var bar = root.querySelector('[data-hybs-bar]'); if (bar) bar.style.width = Math.min(qty/maxQ,1)*100 + '%';
    rowsEl.querySelectorAll('.hybs-row').forEach(function(b){
      var q = +b.dataset.q, on = b.dataset.last==='1' ? qty>=q : qty===q;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
    root.querySelector('[data-hybs-qty]').textContent = qty;
    hidden.value = qty;
    root.querySelector('[data-hybs-count]').textContent = '· ' + qty + ' ' + (qty===1 ? label : plural).toLowerCase();
    var totEl = root.querySelector('[data-hybs-total]');
    totEl.textContent = money(tot);
    if (lastTot !== null && lastTot !== tot){ bump(totEl); if (pct) bump(root.querySelector('[data-hybs-save]')); }
    lastTot = tot;
    var save = root.querySelector('[data-hybs-save]'), fullEl = root.querySelector('[data-hybs-full]');
    save.hidden = fullEl.hidden = !pct;
    if (pct){ save.textContent = 'You save ' + money(full-tot); fullEl.textContent = money(full); }
    var next = tiers.filter(function(t){ return t.q>qty; })[0];
    root.querySelector('[data-hybs-nudge]').textContent = next
      ? 'Add ' + (next.q-qty) + ' more to unlock ' + next.pct + '% off every ' + label.toLowerCase() + '.'
      : 'Max savings unlocked — ' + pct + '% off every ' + label.toLowerCase() + '!';
    root.dispatchEvent(new CustomEvent('hybs:change', {bubbles:true, detail:{quantity:qty, percent:pct, total:tot}}));
  }

  rowsEl.addEventListener('click', function(e){ var b=e.target.closest('.hybs-row'); if(!b) return; qty=+b.dataset.q; update(); });
  rowsEl.addEventListener('keydown', function(e){
    if (['ArrowDown','ArrowRight','ArrowUp','ArrowLeft'].indexOf(e.key)<0) return;
    e.preventDefault();
    var btns = [].slice.call(rowsEl.querySelectorAll('.hybs-row'));
    var i = btns.indexOf(document.activeElement), d = (e.key==='ArrowDown'||e.key==='ArrowRight') ? 1 : -1;
    var n = btns[(i+d+btns.length)%btns.length]; qty=+n.dataset.q; update(); n.focus();
  });
  root.querySelectorAll('[data-hybs-step]').forEach(function(b){
    b.addEventListener('click', function(){ qty = Math.min(99, Math.max(1, qty + (+b.dataset.hybsStep))); update(); });
  });

  // Keep price in sync when the theme's variant (size) picker changes.
  function syncVariant(){
    var idEl = form && form.querySelector('[name="id"]');
    if (idEl && variants[idEl.value] != null && variants[idEl.value] !== price){ price = variants[idEl.value]; renderRows(); update(); }
  }
  if (form){
    form.addEventListener('change', function(){ setTimeout(syncVariant, 0); });
    var idEl = form.querySelector('[name="id"]');
    if (idEl) new MutationObserver(syncVariant).observe(idEl, {attributes:true, attributeFilter:['value']});
  }
  document.addEventListener('variant:change', syncVariant);

  renderRows(); update();
  if ('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(en){ if(en[0].isIntersecting){ rowsEl.classList.add('is-enter'); io.disconnect(); } }, {threshold:.2});
    io.observe(rowsEl);
  }
}

function boot(){ document.querySelectorAll('.hybs').forEach(init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
// Themes that re-render the product block on variant change (Dawn etc.) insert a fresh .hybs — init it.
if ('MutationObserver' in window) {
  var t; new MutationObserver(function(){ clearTimeout(t); t = setTimeout(boot, 30); })
    .observe(document.documentElement, { childList: true, subtree: true });
}
})();
